import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import {
  getArrayWithoutDuplicate,
  getSlug,
  getSectionId,
  getStringWithoutParenthesisAndInnerContent
} from '../utils/getters';

import { useFilters } from '../hooks/useFilters';
import { ALL_FILTERS } from '../utils/variables';
import { useHash } from '../hooks/useHash';

import BlockContent from './BlockContent';
import Filters from './Filters';
import JobListings from './JobListings';

export default function JobBoard({ section }) {
  const { blockContent } = section;
  const data = useStaticQuery(query);
  const jobListings = data.allLever.edges;

  const clearedJobListings = jobListings.map(({ node }) => ({
    ...node,
    categories: {
      team: getStringWithoutParenthesisAndInnerContent(node.categories.team)
    }
  }));

  const getJobCategories = () => {
    const jobCategories = [];
    clearedJobListings.map((listing, i) =>
      jobCategories.push({
        id: `job-listing-category-${i}`,
        title: listing.categories.team,
        identifier: getSlug(listing.categories.team)
      })
    );
    jobCategories.unshift({
      id: ALL_FILTERS.id,
      title: ALL_FILTERS.title
    });

    return getArrayWithoutDuplicate(jobCategories, 'title');
  };

  const { selectedElement, setSelectedElement, isAllFilter } = useFilters(
    getJobCategories()
  );

  const filteredJobListings = () =>
    clearedJobListings.filter(
      (listing) =>
        listing.categories.team === selectedElement.title || isAllFilter()
    );
  // SELECT SPECIFIC JOB CATEGORY BASED ON URL HASH
  useHash(getJobCategories(), setSelectedElement);

  return (
    <>
      {section && (
        <div className="job-board">
          <BlockContent content={blockContent} />
          <Filters
            filters={getJobCategories()}
            handleClick={setSelectedElement}
            selectedElement={selectedElement}
          />
          <JobListings jobListings={filteredJobListings()} />
        </div>
      )}
    </>
  );
}

const query = graphql`
  query {
    allLever {
      edges {
        node {
          ...JobListingFragment
        }
      }
    }
  }
`;
